import lockupUrl from "../assets/brand/dream-calendar-lockup.png";
import markUrl from "../assets/brand/dream-calendar-mark.png";

/**
 * Marca oficial do Dream Calendar.
 *
 * Os PNGs enviados (olho com a grade recortada + lockup "dream / calenDar")
 * entram como imagem, sem reconstrução. São brancos com furos transparentes:
 * no tema claro o CSS inverte para preto; no escuro ficam brancos. O fundo
 * aparece nos furos, então o contraste acompanha o tema.
 *
 * Compacto = só o olho. Completo = ícone à esquerda, wordmark à direita.
 */

export interface DreamLogoProps {
  compact?: boolean;
  /** `lg` = login. `md` = sidebar e portal. */
  size?: "md" | "lg";
}

export function DreamLogo({ compact = false, size = "md" }: DreamLogoProps) {
  const large = size === "lg";
  const height = compact ? (large ? 40 : 28) : large ? 52 : 40;

  return (
    <img
      src={compact ? markUrl : lockupUrl}
      alt="Dream Calendar"
      draggable={false}
      className="dream-brand-mark h-auto w-auto max-w-full min-w-0 object-contain object-left"
      style={{ maxHeight: height }}
    />
  );
}
